import * as React from "react";
import { useBloomreachAppointmentContent } from "@grandvisionhq/bloomreach";
import { useAppointmentContext } from "../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { usePageData } from "../../../../../context/v3/pages/BookAppointment/context/PageDataContext.js";
const useAppointmentTypes = () => {
  const pageData = usePageData();
  const [, { store }] = useAppointmentContext();
  const { appointmentDisplayType } = useBloomreachAppointmentContent();
  const isAabGrouped = appointmentDisplayType === "group";
  const sortedAppointmentTypes = React.useMemo(() => {
    const appointmentTypes = store?.appointmentTypes ?? [];
    return appointmentTypes.sort((a, b) => {
      const pageTypes = pageData.appointmentTypes ?? [];
      const aIndex = pageTypes.findIndex(({ typeId }) => typeId === a.id);
      const bIndex = pageTypes.findIndex(({ typeId }) => typeId === b.id);
      if (aIndex === -1) {
        return 1;
      } else if (bIndex === -1) {
        return -1;
      } else {
        return aIndex - bIndex;
      }
    });
  }, [pageData, store]);
  const groupedAppointmentTypeIcons = React.useMemo(() => {
    if (!isAabGrouped) {
      return {};
    }
    return pageData.appointmentTypes?.reduce(
      (acc, appointmentGroup) => {
        appointmentGroup.appointmentTypes.forEach((entry) => {
          if (entry.icon !== void 0) {
            acc[entry.typeId] = entry.icon;
          }
        });
        return acc;
      },
      {}
    ) ?? {};
  }, [isAabGrouped, pageData]);
  const appointmentTypeIcons = React.useMemo(
    () => pageData.appointmentTypes?.reduce(
      (acc, entry) => {
        if (entry.icon !== void 0) {
          acc[entry.typeId] = entry.icon;
        }
        return acc;
      },
      {}
    ) ?? {},
    [pageData]
  );
  const groupedAppointmentGlobalLabels = React.useMemo(() => {
    if (!isAabGrouped) {
      return {};
    }
    return pageData.appointmentTypes?.reduce(
      (acc, appointmentGroup) => {
        appointmentGroup.appointmentTypes.forEach((entry) => {
          if (entry.globalLabel !== void 0) {
            acc[entry.typeId] = entry.globalLabel;
          }
        });
        return acc;
      },
      {}
    ) ?? {};
  }, [isAabGrouped, pageData]);
  const appointmentGlobalLabels = React.useMemo(
    () => pageData.appointmentTypes?.reduce(
      (acc, entry) => {
        if (entry.globalLabel !== void 0) {
          acc[entry.typeId] = entry.globalLabel;
        }
        return acc;
      },
      {}
    ) ?? {},
    [pageData]
  );
  const groupedAppointmentTypeToolTips = React.useMemo(() => {
    if (!isAabGrouped) {
      return {};
    }
    return pageData.appointmentTypes?.reduce(
      (acc, appointmentGroup) => {
        appointmentGroup.appointmentTypes.forEach((entry) => {
          if (entry.typeDetails !== void 0) {
            acc[entry.typeId] = entry.typeDetails;
          }
        });
        return acc;
      },
      {}
    ) ?? {};
  }, [isAabGrouped, pageData]);
  const appointmentTypeToolTips = React.useMemo(
    () => pageData.appointmentTypes?.reduce(
      (acc, entry) => {
        if (entry.typeDetails !== void 0) {
          acc[entry.typeId] = entry.typeDetails;
        }
        return acc;
      },
      {}
    ) ?? {},
    [pageData.appointmentTypes]
  );
  const groupedAppointmentTypes = React.useMemo(() => {
    if (isAabGrouped) {
      const groupedAppointmentsData = pageData.appointmentTypes?.map(
        (appointmentGroup) => {
          const appointmentTypesFromQuery = store?.appointmentTypes ?? [];
          const groupedAppointmentTypesData = appointmentTypesFromQuery.filter((appointmentTypeFromQuery) => {
            return appointmentGroup.appointmentTypes.some(
              (type) => type.typeId === appointmentTypeFromQuery.id
            );
          }).sort((a, b) => {
            const aIndex = appointmentGroup.appointmentTypes.findIndex(
              ({ typeId }) => typeId === a.id
            );
            const bIndex = appointmentGroup.appointmentTypes.findIndex(
              ({ typeId }) => typeId === b.id
            );
            if (aIndex === -1) {
              return 1;
            } else if (bIndex === -1) {
              return -1;
            } else {
              return aIndex - bIndex;
            }
          });
          return {
            title: appointmentGroup.title,
            icon: appointmentGroup.icon,
            appointmentTypes: groupedAppointmentTypesData
          };
        }
      );
      return groupedAppointmentsData;
    }
    return [];
  }, [isAabGrouped, pageData.appointmentTypes, store?.appointmentTypes]);
  return React.useMemo(
    () => ({
      sortedAppointmentTypes,
      appointmentTypeIcons,
      appointmentGlobalLabels,
      appointmentTypeToolTips,
      groupedAppointmentTypes,
      groupedAppointmentTypeIcons,
      groupedAppointmentTypeToolTips,
      groupedAppointmentGlobalLabels
    }),
    [
      sortedAppointmentTypes,
      appointmentTypeIcons,
      appointmentGlobalLabels,
      appointmentTypeToolTips,
      groupedAppointmentTypes,
      groupedAppointmentTypeIcons,
      groupedAppointmentTypeToolTips,
      groupedAppointmentGlobalLabels
    ]
  );
};
export {
  useAppointmentTypes as default,
  useAppointmentTypes
};
//# sourceMappingURL=use-appointment-types.js.map
